export default (theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
  header: {
    marginBottom: '1rem',
    fontSize: '4rem',
    letterSpacing: '0.1rem',
    textAlign: 'center',
  },
  formContainer: {
    width: '100%',
    maxWidth: '30rem',
    padding: '2rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  formField: {
    marginBottom: '1rem',
  },
  actionButton: {
    marginTop: '1rem',
    color: theme.color.white,
  },
  link: {
    fontSize: '0.88rem',
    color: theme.color.textSecondary,
    fontWeight: 'bold',
  },
})
